import {
	reDistrictConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : [],
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reDistrictConstants.GetPaged.REQUEST:
		case reDistrictConstants.GetPagedAudit.REQUEST:
		case reDistrictConstants.GetPagedAll.REQUEST:
		case reDistrictConstants.GetList.REQUEST:
		case reDistrictConstants.Create.REQUEST:
		case reDistrictConstants.Delete.REQUEST:
		case reDistrictConstants.Restore.REQUEST:
		case reDistrictConstants.Update.REQUEST:
		case reDistrictConstants.getListActualByRegion.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reDistrictConstants.GetPaged.FAILURE:
		case reDistrictConstants.GetPagedAudit.FAILURE:
		case reDistrictConstants.GetPagedAll.FAILURE:
		case reDistrictConstants.GetList.FAILURE:
		case reDistrictConstants.Create.FAILURE:
		case reDistrictConstants.Delete.FAILURE:
		case reDistrictConstants.Restore.FAILURE:
		case reDistrictConstants.Update.FAILURE:
		case reDistrictConstants.getListActualByRegion.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reDistrictConstants.GetPaged.SUCCESS:
		case reDistrictConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reDistrictConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reDistrictConstants.GetList.SUCCESS:
		case reDistrictConstants.getListActualByRegion.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reDistrictConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reDistrictConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reDistrictConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reDistrictConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reDistrictConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : [],
				countAudit : null,
				pagedAudit : null
			}
		default:
			return state
	}
}